// CandidateLayoutContext.js
import React, { createContext, useContext } from "react";

const CandidateLayoutContext = createContext();
const ClientLayoutContext = createContext();
const StaffLayoutContext = createContext();

export const useCandidateLayout = () => useContext(CandidateLayoutContext);
export const useClientLayout = () => useContext(ClientLayoutContext);
export const useStaffLayout = () => useContext(StaffLayoutContext);

export const CandidateLayoutProvider = ({ value, children }) => (
  <CandidateLayoutContext.Provider value={value}>
    {children}
  </CandidateLayoutContext.Provider>
);



export const ClientLayoutProvider = ({ value, children }) => (
  <ClientLayoutContext.Provider value={value}>
    {children}
  </ClientLayoutContext.Provider>
);


export const StaffLayoutProvider = ({ value, children }) => (
  <StaffLayoutContext.Provider value={value}>
    {children}
  </StaffLayoutContext.Provider>
);